const validationMessages = {
  'name': 'Nombre es un campo requerido.',
  'surname': 'Apellidos es un campo requerido.',
  'nationality': 'La Nacionalidad es un campo requerido.',
  'idNumber': 'El NIF (NIE) es un campo requerido.',
  'nifDate': 'La fecha de caducidad del documento no es valida.',
  'birthDate': 'La fecha de nacimiento no es valida.',
  'serverConnection': 'Error en la conexión, por favor inténtelo más tarde.',
  'phoneNumber': 'El número de teléfono es un campo requerido.',
  'notificationEmail': 'El email de notificación es un campo requerido.',
  'notificationEmailFormat': 'El email de notificación no tiene un formato correcto, por favor introduzcalo de nuevo.',
  'email': 'El email es un campo requerido.',
  'emailFormat': 'El email no tiene un formato correcto, por favor introduzcalo de nuevo.',
  'address': 'La dirección es un campo requerido.',
  'houseNumber': 'El piso, escalera, puerta es un campo requerido.',
  'city': 'La ciudad es un campo requerido.',
  'province': 'La provincia es un campo requerido.',
  'zipCode': 'El código postal es un campo requerido',
  'country': 'El país es un campo requerido.',
  'maritalStatus': 'El estado civil es un campo requerido.',
  'maritalEconomicStatus': 'El estado económico matrimonial es un campo requerido.',
  'maritalPropertyRegime': 'El tipo de régimen de gananciales es un campo requerido.',
  'occupationType': 'El tipo de occupación es un campo requerido.',
  'enterpriseName': 'El nombre de la empresa es un campo requerido.',
  'establishmentDate': 'La fecha de constitución es un campo requerido.',
  'notaryName': 'El nombre del notario es un campo requerido.',
  'notaryAddress': 'La dirección del notario es un campo requerido.',
  'protocolNumber': 'El número de protocolo es un campo requerido.',
  'cifNumber': 'El CIF es un campo requerido.',
  'provinceCommercialRegister': 'La provincia del registro mercantil es un campo requerido.',
  'corporateEmail': 'El email corporativo es un campo requerido.',
  'corporateEmailFormat': 'El email corporativo no tiene un formato correcto, por favor introduzcalo de nuevo.',
  'volumeNumber': 'El número de volumen es un campo requerido.',
  'sheetNumber': 'El número de hoja es un campo requerido.',
  'pageNumber': 'El número de página es un campo requerido.',
  'companyProxy': 'El cargo de poderes es un campo requerido.',
  'establishmentRepresentativeDate': 'La fecha de constitución de la sociedad es un campo requerido.',
  'provinceDeed': 'La provincia de escritura es un campo requerido.',
  'notaryProxyName': 'El nombre de notario de la otorgación de poder es un campo requerido.',
  'protocolProxyNumber': 'El número de protocolo de la otorgación de poder es un campo requerido.',
  'emailTaken': 'El email ya existe.',
  'emailIncorrect': 'El email introducido no tiene un formato correcto, por favor introduzcalo de nuevo.',
  'password': 'La contraseña no es valida',
  'confirmPassword': 'Las contraseñas no coinciden',
  'terms': 'Debe aceptar los terminos y condiciones.',
  'nifExpiration': 'La fecha de caducidad del documento no es valida.',
  'emptyInvestment': 'Tienes que invertir como mínimo un tiquet.',
  'confirmationCode': 'Código de confirmación inválido.',
  'incompleteProfile':
    'El perfil está incompleto, para poder acreditarlo debes introducir todos los campos obligatorios.',
  'iban': 'El IBAN es un campo requerido.',
  'ibanFormat': 'El IBAN no tiene un formato correcto, por favor introduzcalo de nuevo.',
  'swiftBic': 'El código SWIFT/BIC es un campo requerido.',
  'description': 'La descripción es un campo requerido.',
  'logo': 'El logo es un campo requerido.',
  'cifDocument': 'El documento del CIF es un campo requerido.',
  'deedCompany': 'La escritura de la empresa es un documento requerido.',
  'companyStatutes': 'Los estatutos de la empresa es un documento requerido.',
  'realOwnership': 'La titularidad real es un documento requerido.',
  'idRepresentatives': 'Los documentos de identidad de los representantes son documentos requeridos.',
  'notarialDeed': 'La escritura notarial es un documento requerido.',
  'idFront': 'La parte frontal de Documento de identidad es un campo requerido.',
  'idBack': 'La parte posterior de Documento de identidad es un campo requerido.',
  'spouseName': 'Nombre del cónyuge es un campo requerido.',
  'spouseSurname': 'Apellido del cónyuge es un campo requerido.',
  'spouseNationality': 'La nacionalidad del cónyuge es un campo requerido.',
  'spouseIdNumber': 'El NIF (NIE) del cónyuge es un campo requerido.',
  'spouseNifDate': 'La fecha de caducidad del documento del cónyuge no es valida.',
  'spouseBirthDate': 'La fecha de nacimiento del cónyuge no es valida.',
  'spouseAddress': 'La dirección del cónyuge es un campo requerido.',
  'spouseHouseNumber': 'El piso, escalera, puerta del cónyuge es un campo requerido.',
  'spouseCity': 'La ciudad del cónyuge es un campo requerido.',
  'spouseProvince': 'La provincia del cónyuge es un campo requerido.',
  'spouseZipCode': 'El código postal del cónyuge es un campo requerido',
  'spouseCountry': 'El país del cónyuge es un campo requerido.',
  'jobTitle': 'La posición es un campo requerido.',
  'investmentType': 'El tipo de inversión es un campo requerido.',
  'amountInvested': 'El importe tiene que ser mayor que 0.',
  'fileSize': 'El tamaño del archivo no puede ser superior a 20Mb.',

  // Backend Messages
  'The email must be a valid email address.':
    'El email introducido no tiene un formato correcto, por favor introduzcalo de nuevo.',
  'The password must be at least 5 characters.': 'La contraseña debe contener al menos 5 caracteres.',
  'The new password must be at least 5 characters.': 'La contraseña debe contener al menos 5 caracteres.',
  'The password format is invalid.':
    'La contraseña debe contener ' +
    'al menos una mayúscula, al menos un número y al menos un símbolo (#,@,%…).',
  'The selected terms and conditions is invalid.': 'Debe aceptar los terminos y condiciones.',
  'The confirm new password and new password must match.': 'Las contraseñas no coinciden.',
  'The new password format is invalid.': 'El formato de la nueva contraseña no es válido.',
  'Wrong current password': 'La contraseña actual és incorrecta.',
  'The current password field is required.': 'La contraseña actual es un campo requerido.',
  'The new password field is required.': 'La contraseña nueva es un campo requerido.',
  'The confirm new password field is required.': 'Debes confirmar la contraseña.',
  'The email has already been taken.': 'Ya existe una cuenta con este email.',
  'The cif document field is required.': 'Debes subir una imagen del documento de identificación fiscal.',
  'The cif number field is required.': 'El cif es un campo obligatorio.',
  'The deed company field is required.': 'Debes subir una imagen de las escrituras de la empresa.',
  'The company statutes field is required.': 'Debes subir una imagen del documento de los estatutos de la empresa.',
  'The real ownership field is required.': 'Debes subir una imagen del documento de titularidad real.',
  'The id representatives field is required.': 'Debes subir una imagen del documento ' +
    'de identificación de los representantes.',
  'The notarial deed field is required.': 'Debes subir una imagen del documento de la escritura notarial.',
  'The selected email is invalid.': 'No existe ningún usuario con este email.',
  'The message field is required.': 'Debes escribir un mensaje indicando cuál es la incidencia.',
  'The corrected contract field is required.': 'Debes indicar en que documento o documentos está la errata.',
  'The error field is required.': 'Debes indicar en que tienes dudas.',
  'The zip code format is invalid.': 'El formato del código postal no es válido.',
  'The contact zip code format is invalid.': 'El formato del código postal no es válido.',
  'The phone number format is invalid.': 'El formato del número de teléfono no es válido.',
  'The contact phone number format is invalid.': 'El formato del número de teléfono no es válido.',
  'The id number format is invalid.': 'El formato del NIF o NIE no es válido.',
  'The contact nif format is invalid.': 'El formato del NIF o NIE no es válido.',
  'Wrong confirmation message.': 'Respuesta incorrecta, por favor vuelva a introducirla.',
  'Bad test. Choice not found.': 'Tienes que responder a todas las preguntas del test.',
  'The name field is required.': 'Tienes que introducir tu nombre.',
  'The surname field is required.': 'Tienes que introducir tus apellido/s.',
  'The email field is required.': 'Tienes que introducir tu email.',
  'The country field is required.': 'Tienes que introducir tu país.',
  'The id front field is required.': 'Tienes que subir la parte frontal de tu DNI.',
  'The id back field is required.': 'Tienes que subir la parte posterior de tu DNI.',
  'The enterprise name field is required.': 'Tienes que introducir el nombre de tu empresa.',
  'The corporate email field is required.': 'Tienes que introducir el email de tu empresa.',
  'The birth date field is required.': 'Tienes que introducir la fecha de nacimiento.',
  'User has already created JuridicalPerson for this Company.': 'Ya has creado una Persona Jurídica para esta empresa.',
};

export default validationMessages;



// WEBPACK FOOTER //
// ./src/stubs/validationMessages.tsx